import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import ReactTooltip from 'react-tooltip';
import { Notifs } from 'redux-notifications';
import Cookie from 'js-cookie';

import FatalError from '../ui/Pages/Errors/500';
import MainMenu from '../ui/Menu/MainMenu';
import Footer from '../ui/Footer';
import routes from '../routes';
import AuthForm from '../ui/AuthForm/AuthForm';
import AuthModal from '../ui/AuthForm/AuthModal';
import CommentForm from '../ui/Controls/Comments/CommentForm';
import { PriceSubscriptionForm } from '../ui/Controls/Subscriptions';
import ClaimForm from '../ui/Controls/Claims/ClaimForm';
import MapsModal from '../ui/Maps/MapsModal';
import CianUnion from '../ui/CianUnion/CianUnion';

import { initialize } from '../utils/googleAnalytics';
import { sendEvent } from '../utils/yandexMetrika';

import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';

class App extends Component {
  constructor (props) {
    super(props);

    this.state = { hasError: false, error: null };
  }
  componentDidMount () {
    const { user, cianModalContext } = this.props;
    const loaded = user.get('loaded');

    const config = {
      page: this.props.location.pathname,
      dimension1: 'mlsn:new-design'
    };

    if (loaded) {
      config['dimension11'] = user.getIn(['data', 'id']);
      config['dimension13'] = user.getIn(['data', 'isRealtor']) ? 'pro:realtor' : 'owner';
    }

    initialize(config);

    sendEvent('view-mode');
    const isCianModal = Cookie.get('unionCianModal') || null;
    if (!isCianModal) {
      // показываем каждые cianModalContext.frequency дней <CianUnion />
      Cookie.set('unionCianModal', '1', { expires: cianModalContext.frequency });
    }
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error };
  }

  componentDidCatch (error, errorInfo) {
    window && Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  render () {
    const { cianModalContext } = this.props;
    return (
      <div className='page'>
        <Helmet
          htmlAttributes={{ lang: 'ru' }}
          meta={[
            {
              'name': 'description',
              'content': 'На портале омской недвижимости вы найдете ' +
              'большое количество объявлений о покупке и продаже квартир, ' +
              'съеме и сдаче в аренду как от собственников, так и от риэлторов'
            }, {
              'name': 'keywords',
              'content': 'недвижимость, недвижимость без посредников, недвижимость в омске, ' +
              'недвижимость в омске без посредников, недвижимость в омске продажа квартир, ' +
              'недвижимость продажа квартир, омская недвижимость, омский портал недвижимости, ' +
              'продажа недвижимости, продажа недвижимости в омске'
            }
          ]}
          defaultTitle='Недвижимость в Омске - MLSN.RU'
        />
        <MainMenu />
        <div className='page-content'>
          { this.state.hasError ? <FatalError /> : routes }
        </div>
        <Footer />
        <ReactTooltip effect='solid' />
        <ReactTooltip id='tip-favorite' effect='solid' getContent={(e) => 'Добавить в избранное'} />
        <ReactTooltip id='tip-remove-favorite' effect='solid' getContent={() => 'Удалить из избранного'} />
        <ReactTooltip id='tip-comments' effect='solid' getContent={() => 'Комментарии'} />
        <ReactTooltip id='tip-claim' effect='solid' getContent={() => 'Пожаловаться'} />
        <ReactTooltip id='tip-trash' effect='solid' getContent={() => 'Удалить'} />
        <ReactTooltip id='tip-edit' effect='solid' getContent={() => 'Редактировать'} />
        <ReactTooltip id='tip-profile' effect='solid' getContent={() => 'Профиль пользователя'} />
        <ReactTooltip id='tip-maps' effect='solid' getContent={() => 'Показать на карте'} />
        <ReactTooltip id='tip-price-subscription' effect='solid' getContent={() => 'Подписаться на изменение цены'} />
        <ReactTooltip id='tip-price-history' effect='solid' getContent={() => 'Динамика изменение цены'} />
        <ReactTooltip id='tip-mlsn-union-cian' effect='solid' place='bottom'>
          <div>
            Циан и МЛСН одна компания! <br />
            Попробуйте поиск в Циан
          </div>
        </ReactTooltip>
        <ReactTooltip id='tip-trusted' place='right' effect='solid' class='popover-services popover-trusted'>
          <div className='title'>
            <svg style={{zoom: 2}} xmlns='http://www.w3.org/2000/svg' width='24' height='24'>
              <path fill='#749B0A' fillRule='nonzero' d='M11.235 2.158L4.624 5.01A1.84 1.84 0 0 0 3.5 6.688v4.31C3.5 16.085 7.127 20.844 12 22c4.873-1.155 8.5-5.914 8.5-11.003v-4.31a1.84 1.84 0 0 0-1.124-1.677l-6.611-2.852a1.93 1.93 0 0 0-1.53 0zm-1.794 13.69l-2.447-2.375a.894.894 0 0 1 0-1.293.96.96 0 0 1 1.332 0l1.785 1.724 5.553-5.392a.96.96 0 0 1 1.332 0 .894.894 0 0 1 0 1.293l-6.224 6.043a.96.96 0 0 1-1.331 0z' />
            </svg>
            <div>
              <p>Участвует в программе<b><br />«Можно доверять»</b></p>
            </div>
          </div>
          <div className='content'>
            <p>Участие в программе «Можно доверять» означает, что данный пользователь (агентство недвижимости, частный риэлтор, застройщик) взял на себя добровольное обязательство по размещению в своих объявлениях 100% достоверной информации (фото, цена, описание соответствует реальному объекту на продажу/аренду).</p>
            <p>Внимание! Если Вы заметили в объявлениях данного пользователя заведомо ложную информацию, просьба сообщить об этом администрации сайта через функцию "Пожаловаться"</p>
          </div>
        </ReactTooltip>
        <ReactTooltip id='tip-premium' place='right' effect='solid' class='popover-services popover-premium'>
          <div className='title'>
            <span className='icon-premium'>
              <span className='path1' />
              <span className='path2' />
            </span>
            <div>
              <p>Премиум</p>
            </div>
          </div>
          <div className='content'>
            <p>Премиум объявления фиксируются в результатах поиска + показываются "сквозным размещением" (в ротации) на всех страницах соответствующей рубрики.</p>
            <p>Повышает количество просмотров в 5–10 раз по сравнению с обычным объявлением</p>
          </div>
        </ReactTooltip>
        <ReactTooltip id='tip-promo' place='right' effect='solid' class='popover-services popover-promo'>
          <div className='title'>
            <span className='icon-promo'>
              <span className='path1' />
              <span className='path2' />
            </span>
            <div>
              <p>Промо</p>
            </div>
          </div>
          <div className='content'>
            <p>Промо объявления фиксируются вверху в результатах поиска сразу же после "Премиум" объявлений.</p>
            <p>Повышает количество просмотров в среднем в 3 раз по сравнению с обычным объявлением</p>
          </div>
        </ReactTooltip>
        <Notifs />

        <AuthForm />
        <AuthModal />
        <CommentForm />
        <PriceSubscriptionForm />
        <ClaimForm />
        <MapsModal />
        <CianUnion isOpenModal={!Cookie.get('unionCianModal') && cianModalContext.is_visible} />
      </div>
    );
  }
}

App.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  user: PropTypes.object,
  cianModalContext: PropTypes.object
};

function mapStateToProps (state) {
  return {
    user: state.get('user'),
    cianModalContext: state.getIn(['home', 'cian_modal_context'], { is_visible: false }).toJS()
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/app/App.js